// Configurația secțiunilor HR Dashboard: { id, label, subtitle, icon, component }.
// Extrasă din HrDashboard.vue pentru modularitate + testabilitate. `t` este funcția
// de traducere (vue-i18n); `isAdmin` decide secțiunea exclusiv de administrare.
export const buildHrDashboardMenuOptions = ({ t, isAdmin = false } = {}) => {
  const translate = typeof t === "function" ? t : (key) => key;
  const options = [];

  if (isAdmin) {
    options.push({
      id: "company-management",
      label: translate("hrDashboard.menuItems.companyManagement.label"),
      subtitle: translate("hrDashboard.menuItems.companyManagement.subtitle"),
      icon: "mdi-domain",
      component: "Companies",
    });
  }

  options.push(
    {
      id: "company-board",
      label: translate("hrDashboard.menuItems.companyBoard.label"),
      subtitle: translate("hrDashboard.menuItems.companyBoard.subtitle"),
      icon: "mdi-view-dashboard-outline",
      component: "CompanyDetails",
    },
    {
      id: "employee-management",
      label: translate("hrDashboard.menuItems.employeeManagement.label"),
      subtitle: translate("hrDashboard.menuItems.employeeManagement.subtitle"),
      icon: "mdi-account-multiple-outline",
      component: "Employees",
    },
    {
      id: "checklist",
      label: translate("hrDashboard.menuItems.checklist.label"),
      subtitle: translate("hrDashboard.menuItems.checklist.subtitle"),
      icon: "mdi-format-list-checks",
      component: "ChecklistPanel",
    },
    {
      id: "my-data",
      label: translate("hrDashboard.menuItems.myData.label"),
      subtitle: translate("hrDashboard.menuItems.myData.subtitle"),
      icon: "mdi-account-circle",
      component: "EmployeeDetails",
    },
    {
      id: "my-timesheet",
      label: translate("hrDashboard.menuItems.myTimesheet.label"),
      subtitle: translate("hrDashboard.menuItems.myTimesheet.subtitle"),
      icon: "mdi-clock-time-four-outline",
      component: "EmployeeTimesheet",
    },
    {
      id: "annual-leave",
      label: translate("hrDashboard.menuItems.annualLeave.label"),
      subtitle: translate("hrDashboard.menuItems.annualLeave.subtitle"),
      icon: "mdi-beach",
      component: "ZileLibere",
    },
    {
      id: "user-account",
      label: translate("hrDashboard.menuItems.userAccount.label"),
      subtitle: translate("hrDashboard.menuItems.userAccount.subtitle"),
      icon: "mdi-account-key",
      component: "UserAccountSettings",
    },
    {
      id: "my-files",
      label: translate("hrDashboard.menuItems.myFiles.label"),
      subtitle: translate("hrDashboard.menuItems.myFiles.subtitle"),
      icon: "mdi-folder-account",
      component: "EmployeeFiles",
    },
    {
      id: "finance",
      label: translate("hrDashboard.menuItems.finance.label"),
      subtitle: translate("hrDashboard.menuItems.finance.subtitle"),
      icon: "mdi-cash-multiple",
      component: "EmployeeFinance",
    }
  );
  // Notă: Recrutare / Candidați / Upload CV NU sunt secțiuni in-dashboard; au rute dedicate
  // (pagini complete) lansate din meniul HR Dashboard — vezi buildHrDashboardMenu + router.

  return options;
};
